export default __webpack_public_path__ + "static/media/Stalker's Mask of Shattered Souls.362d30d7.jpg";